import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

interface HelpVisibilityState {
    isVisible: boolean;
}

const initialState: HelpVisibilityState = {
    isVisible: false
};

const helpVisibilitySlice = createSlice({
    name: 'helpVisibility',
    initialState,
    reducers: {
        toggleHelpVisibility: (state) => {
            state.isVisible = !state.isVisible;
        },
        setHelpVisibility: (state, action) => {
            state.isVisible = action.payload;
        }
    }
});

export const { toggleHelpVisibility, setHelpVisibility } = helpVisibilitySlice.actions;

const persistConfig = {
    key: 'helpVisibility',
    storage,
    whitelist: ['isVisible']
};

export const persistedHelpVisibilityReducer = persistReducer(persistConfig, helpVisibilitySlice.reducer);
